import React, { Component } from 'react';
import { Modal, Header, List, Image, Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import GiftBlackSvg from '../../assets/icons/gift_black.svg';
import CloseSvg from '../../assets/icons/close.svg';
import ExternalArrowTealSvg from '../../assets/icons/external_arrow_teal.svg';
import HowToAddBankerImage from '../../assets/images/hlb_campaign/how_to_add_banker_1.png';
import HLBCampaignMainBanner from './HLBCampaignMainBanner';
import HLBCampaignTncModal from './HLBCampaignTncModal';
import HLBCampaignJoinModal from './HLBCampaignJoinModal';

class HLBCampaignInfoModal extends Component {
  static propTypes = {
    show: PropTypes.bool,
    handleOnClose: PropTypes.func,
  }
  constructor(props) {
    super(props);
    this.state = {
      openTncModal: false,
      showHLBJoinModal: false,
    };
  }
  handleOnJoin = () => {
    this.setState({ showHLBJoinModal: true });
  }
  handleOnCloseJoin = () => {
    this.setState({ showHLBJoinModal: false });
    this.props.handleOnClose();
  }
  handleOnOpenTnc = async () => {
    this.setState({ openTncModal: true });
  }
  handleOnCloseTnc = () => {
    this.setState({ openTncModal: false });
  }
  render() {
    const { show } = this.props;
    return (
      <Modal size="small" open={show} onClose={this.props.handleOnClose}>
        <Modal.Header style={{ fontWeight: '600' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', justifyContent: 'start', gap: '0.5em', alignItems: 'center' }}>
              <img
                src={GiftBlackSvg}
                width={24}
                alt="gift"
              />
              <span style={{ fontSize: '18px' }}>MHub Rewards</span>
            </div>
            <button
              type="button"
              onClick={this.props.handleOnClose}
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
              aria-label="Close"
            >
              <img
                src={CloseSvg}
                width={20}
                alt="close"
              />
            </button>
          </div>
        </Modal.Header>
        <Modal.Content className="hlb-campaign-welcome-modal-content">
          <Modal.Description>
            <HLBCampaignMainBanner />
          </Modal.Description>
          <Modal.Description style={{ marginTop: '1em' }}>
            <Header>Cash Rewards</Header>
            <List bulleted>
              <List.Item>
                Earn RM10 for every case you send to Hong Leong Bank through MHub Showroom
              </List.Item>
              <List.Item>
                Valid only for cases sent during the Campaign period and for projects where HLB appears as panel bank
              </List.Item>
            </List>
          </Modal.Description>
          <Modal.Description style={{ marginTop: '1em' }}>
            <Header>More Info</Header>
            <List bulleted>
              <List.Item>
                Choose any of the Hong Leong Bank bankers in Showroom to qualify for cash payout
              </List.Item>
              <List.Item>
                You will only be eligible for the cash payout if you submit your bank account details. Those who don't will not be entitled. <Link className="hlb-campaign-link" onClick={this.handleOnJoin} style={{ textDecoration: 'underline' }}>Click here to submit</Link>
              </List.Item>
              <List.Item>
                Cash payout will be made on the 15th and 30th of every month to the account that you nominated
              </List.Item>
              <List.Item>
                Only eligible for project with Hong Leong Bank End-financing
              </List.Item>
              <List.Item>
                Project that has no end-financing available quota won&apos;t be eligible for this campaign
              </List.Item>
              <List.Item>
                You can also send cases to bankers from other banks in Showroom however you will not be eligible for cash payout for those cases
              </List.Item>
            </List>
          </Modal.Description>
          <Modal.Description style={{ marginTop: '1em' }}>
            <Header>How to add Banker</Header>
            <Image src={HowToAddBankerImage} />
          </Modal.Description>
          <Modal.Description style={{ marginTop: '1em' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Link
                className="hlb-campaign-link"
                style={{ display: 'flex', alignItems: 'center', gap: '0.5em', textDecoration: 'none' }}
                onClick={this.handleOnOpenTnc}
              >
                <img src={ExternalArrowTealSvg} width={10} alt="external link" />
                <span style={{ fontWeight: '600' }}>
                  Terms and conditions
                </span>
              </Link>
              <Button style={{ backgroundColor: '#0094B3', color: '#FFFFFF' }} content="Join" onClick={this.handleOnJoin} />
            </div>
          </Modal.Description>
          <HLBCampaignTncModal
            open={this.state.openTncModal}
            onClose={this.handleOnCloseTnc}
          />
          <HLBCampaignJoinModal
            show={this.state.showHLBJoinModal}
            onClose={this.handleOnCloseJoin}
          />
        </Modal.Content>
      </Modal>
    );
  }
}

export default HLBCampaignInfoModal;



// WEBPACK FOOTER //
// ./src/components/HLBCampaign/HLBCampaignInfoModal.jsx